export const answerChoicePrefix = "answerChoice";